import { Parser } from 'html-to-react'

export const htmlToReactParser = new Parser()